import { ArtikelauswahlGanter } from "@/legacy/artikelauswahlClient/ganter";
import { ArtikelauswahlInocon } from "@/legacy/artikelauswahlClient/inocon";
import type { ArtikelauswahlApiResponse } from "@/lib/models/artikelauswahl";
import type { WarenkorbTyp } from "@/lib/models/warenkorb";
import { environment } from "@/lib/resources";

export interface ArtikelauswahlClientImplementation {
	SetArtikelauswahlArtikelnummer(artikelNr: string): void;
	AktualisiereMengenAnzeige(warenkorbTyp: WarenkorbTyp, anzahlPositionen: number): void;
	SetArtikelauswahlNormblattBild(data: ArtikelauswahlApiResponse): void;
}

export default environment.inocon ? new ArtikelauswahlInocon() : new ArtikelauswahlGanter();
